"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.storeOptionsDefault = void 0;
const constants_1 = require("./constants");
exports.storeOptionsDefault = {
    debug: false,
    prefix: 'mb',
    storage: constants_1.StorageLocation.Local,
};
//# sourceMappingURL=options.js.map